<template>
  <td class="order-detail exchange-color-0">
    <ul>
      <li v-for="(item, index) in items" :key="index" style="padding: 0">
        {{ item.name }}
        <a-badge :count="'×' + item.amount" />
      </li>
    </ul>
  </td>
</template>
<script>
export default {
  name: 'SaibItemDetail',
  props: ['items'],
};
</script>
